// Remembers which walkthrough task the user was last acting on (e.g. the task they clicked
// "Send Note" from) so that when they switch back from the Notes tab to the Overview tab we can
// expand and scroll that task back into view — landing them where they were. Keyed by walkthrough
// id and kept in module memory (cleared on full reload, which is fine — tab switches stay within
// the SPA). The Overview reuses its existing `?taskTitleId` expand-and-scroll behavior to apply it.

const lastViewedTaskByWalkthroughId: Map<string, string> = new Map();

export const setLastViewedWalkthroughTask = (walkthroughId: string, taskTitleId: string): void => {
	if (!walkthroughId || !taskTitleId) return;
	lastViewedTaskByWalkthroughId.set(String(walkthroughId), String(taskTitleId));
};

export const getLastViewedWalkthroughTask = (walkthroughId: string): string | undefined =>
	lastViewedTaskByWalkthroughId.get(String(walkthroughId));

export const clearLastViewedWalkthroughTask = (walkthroughId: string): void => {
	lastViewedTaskByWalkthroughId.delete(String(walkthroughId));
};
